import React, { useState, useRef } from 'react';

const Subheading: React.FC<{ title: string }> = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const subheadingRef = useRef(null);

  return (
    <div className="subheading">
      <h2 onClick={() => setIsOpen(!isOpen)} className="subheading-title">
        <span className="toggle-icon">{isOpen ? '▼' : '▲'}</span>
        {title}
      </h2>
      {isOpen && <div className="subheading-content">{children}</div>}
    </div>
  );
};

export default Subheading;
